var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report",on:{"click":function($event){return _vm.openModal()}}},[_c('img',{attrs:{"src":"/report.svg"}}),_vm._v(" "+_vm._s(_vm.customDisplayMessage || this.displayMessageAccordingToReportType(_vm.reportFor))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }